"use client";
//#region packages/@mantine/core/src/core/utils/filter-props/filter-props.ts
function filterProps(props) {
	return Object.keys(props).reduce((acc, key) => {
		if (props[key] !== void 0) acc[key] = props[key];
		return acc;
	}, {});
}
//#endregion
export { filterProps };

//# sourceMappingURL=filter-props.mjs.map